"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px; */\n  font-weight: ", ";\n  font-size: 0.875rem;\n  display: flex;\n  margin-bottom: 0.5rem;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  span {\n    text-transform: none;\n    font-weight: normal;\n    font-size: 0.8rem;\n    display: inline-flex;\n    margin-left: 1rem;\n    opacity: 0.8;\n    /* align-self: flex-end;\n    margin-left: auto; */\n  }\n"], ["\n  /* font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px; */\n  font-weight: ", ";\n  font-size: 0.875rem;\n  display: flex;\n  margin-bottom: 0.5rem;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  span {\n    text-transform: none;\n    font-weight: normal;\n    font-size: 0.8rem;\n    display: inline-flex;\n    margin-left: 1rem;\n    opacity: 0.8;\n    /* align-self: flex-end;\n    margin-left: auto; */\n  }\n"])), function (_a) {
    var weight = _a.weight;
    return weight || '600';
}, function (_a) {
    var theme = _a.theme, color = _a.color;
    return color || theme.colors.text;
});
var FormLabel = function (props) {
    return react_1.default.createElement(Label, __assign({}, props));
};
exports.default = FormLabel;
var templateObject_1;
